import icons from "./icons";
import ShIconWithDescription from '@/components/Helpers/ShIconWithDescription';

export default {
  name: 'CampaignEdit',

  components: {
    ShIconWithDescription
  },

  props: {
    projectUuid: {
      type: String,
      default: '',
    },
    campaignUuid: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      action: 'create',
      form: {
        name: '',
        color: '#1E90FF',
        icon: 'fas fa-comment-dots',
        campaignTypeUuid: '',
        survey: '',
      },
      icons: icons.icons,
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
      ],
      rules: {
        name: [
          { required: true, message: 'Typ kampanii jest wymagany.', trigger: 'blur' },
        ],
        campaignTypeUuid: [
          { required: true, message: 'Typ kampanii jest wymagany.', trigger: 'blur' },
        ],
      }
    }
  },
  watch: {
    'form.campaignTypeUuid': {
      handler() {
        this.form.icon = this.currentSelectedCampaignType.effect_icon;
        this.form.color = this.currentSelectedCampaignType.effect_color;
        this.form.survey = (this.surveysList.filter(survey => survey.survey_id === this.currentSelectedCampaignType.id_survey))[0]?.uuid
      }
    },
    action: {
      handler() {
        this.form.name = '';
        this.form.color = '#1E90FF';
        this.form.icon = 'fas fa-comment-dots';
        this.form.campaignTypeUuid = '';
        this.form.survey = '';
      }
    }
  },
  computed: {
    statusAndRecordDictionary() {
      return this.$store.getters['campaign/statusAndRecordDictionary'];
    },
    currentSelectedCampaignType() {
      return this.statusAndRecordDictionary.record_dictionary.filter(record => this.form.campaignTypeUuid === record.uuid)[0];
    },
    surveysList() {
      return this.$store.getters['campaign/surveysList'];
    }
  },
  async created() {
    await this.$store.dispatch('campaign/getAllStatusAndRecordDictionary', {projectUuid: this.projectUuid, dialoutUuid: this.campaignUuid});
    await this.$store.dispatch('campaign/getSurveysList', this.projectUuid);
  },
  methods: {
    selectCampaignType() {

    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.action === 'create') {
            const params = {
              effect_name: this.form.name,
              effect_color: this.form.color,
              effect_icon: this.form.icon,
              project_uuid: this.projectUuid,
              survey_uuid: this.form.survey,
              dialout_uuid: this.campaignUuid
            }
            if (!this.form.survey) delete params.survey_uuid
            const responseStatus = await this.$store.dispatch('campaign/createCampaignType', params);
            if (responseStatus === 200) {
              this.$message({
                type: 'success',
                message: 'Nowy typ został utworzony.',
              });
              this.$store.dispatch('campaign/getAllStatusAndRecordDictionary', {projectUuid: this.projectUuid, dialoutUuid: this.campaignUuid});
              this.clearAfterSubmit();
            } else {
              this.$message({
                type: 'error',
                message: "Wystąpił błąd tworzenia nowego typu kampanii",
              });
            }
          } else {
            const params = {
              campaign_type_uuid: this.form.campaignTypeUuid,
              effect_color: this.form.color,
              effect_icon: this.form.icon,
              project_uuid: this.projectUuid,
              survey_uuid: this.form.survey,
            }
            if (!this.form.survey) delete params.survey_uuid
            const responseStatus = await this.$store.dispatch('campaign/editCampaignType', params);
            if (responseStatus === 200) {
              this.$message({
                type: 'success',
                message: "Zmiany zostały zapisane.",
              });
              this.$store.dispatch('campaign/getAllStatusAndRecordDictionary', {projectUuid: this.projectUuid, dialoutUuid: this.campaignUuid});
            } else {
              this.$message({
                type: 'error',
                message: "Wystąpił błąd podczas edycji typu kampanii",
              });
            }
          }
        }
      });
    },
  },

}

